/**
 * request 方法
 */
import { BridgeType, callGrowthMSIBridge, getBridgeType } from "./base";

interface LxCallbackProps {
  errMsg: string;
  errno: number;
}

/* ----- GrowthMSI.lxTrackMPT 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=base&id=1719
interface GrowthMSILxTrackMPTProps {
  channelName?: string;
  pageInfoKey?: string; // PV 事件的唯一索引
  cid?: string; // cid
  param?: Record<string, string | number | null>; // 事件参数
  success?: (res: LxCallbackProps) => void;
  complete?: (res: LxCallbackProps) => void;
  fail?: (err: LxCallbackProps) => void;
}
/* ----- GrowthMSI.lxTrackMPT 类型声明 end ----- */

/* ----- GrowthMSI.lxTrackPD 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=base&id=1723
interface GrowthMSILxTrackPDProps {
  success?: (res: LxCallbackProps) => void;
  complete?: (res: LxCallbackProps) => void;
  fail?: (err: LxCallbackProps) => void;
}
/* ----- GrowthMSI.lxTrackPD 类型声明 end ----- */

/* ----- GrowthMSI.lxTrackModuleClick 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=base&id=1720
interface GrowthMSILxTrackModuleClickProps {
  val_bid: string; // 模块 id
  val_cid: string; // 模块 cid
  val_lab?: Record<string, string | number | null>; // 自定义数据上报
  channelName: string; // 渠道名称
  success?: (res: LxCallbackProps) => void;
  complete?: (res: LxCallbackProps) => void;
  fail?: (err: LxCallbackProps) => void;
}
/* ----- GrowthMSI.lxTrackModuleClick 类型声明 end ----- */

/* ----- GrowthMSI.lxTrackModuleView 类型声明 start ----- */
// https://msi-extend.sankuai.com/api?tab=base&id=1718
type GrowthMSILxTrackModuleViewProps = GrowthMSILxTrackModuleClickProps;
/* ----- GrowthMSI.lxTrackModuleView 类型声明 end ----- */

const bridgeType = getBridgeType();

export interface ReportPageViewProps {
  channelName: string;
  cid: string; // cid
  valLab?: Record<string, string | number | null>; // 自定义参数
  success?: (res: LxCallbackProps) => void;
}

/**
 * 上报页面 PV 事件
 */
export function reportPageView(props?: ReportPageViewProps) {
  switch (bridgeType) {
    case BridgeType.KNB:
      break;
    case BridgeType.MSI:
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("lxTrackMPT", {
        channelName: props?.channelName,
        // pageInfoKey: props?.pageInfoKey, // TODO 确认是否需要
        cid: props?.cid,
        param: props?.valLab,
        success: (res) => {
          if (typeof props?.success === "function") {
            props.success(res);
          }
        },
        fail: (err) => {
          console.error("[reportPageView] LxTrackMPT fail", err);
        }
      } as GrowthMSILxTrackMPTProps);
      break;
    default:
      break;
  }
}

/**
 * 上报页面 PD 事件
 */
export function reportPageDisappear() {
  switch (bridgeType) {
    case BridgeType.KNB:
      break;
    case BridgeType.MSI:
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("lxTrackPD", {} as GrowthMSILxTrackPDProps);
      break;
    default:
      break;
  }
}

interface ReportModuleClickProps {
  channelName: string;
  cid: string; // cid
  bid: string; // bid
  valLab?: Record<string, string | number | null>; // 事件参数
}

/**
 * 上报模块点击事件
 */
export function reportModuleClick(props: ReportModuleClickProps) {
  switch (bridgeType) {
    case BridgeType.KNB:
      break;
    case BridgeType.MSI:
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("lxTrackModuleClick", {
        val_bid: props.bid,
        val_cid: props.cid,
        val_lab: props.valLab,
        channelName: props.channelName,
      } as GrowthMSILxTrackModuleClickProps);
      break;
    default:
      break;
  }
}


/**
 * 上报模块展示事件
 */
type ReportModuleViewProps = ReportModuleClickProps;
export function reportModuleView(props: ReportModuleViewProps) {
  switch (bridgeType) {
    case BridgeType.KNB:
      break;
    case BridgeType.MSI:
      break;
    case BridgeType.GROWTH_MSI:
      callGrowthMSIBridge("lxTrackModuleView", {
        val_bid: props.bid,
        val_cid: props.cid,
        val_lab: props.valLab,
        channelName: props.channelName,
      } as GrowthMSILxTrackModuleViewProps);
      break;
    default:
      break;
  }
}
